// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".img-max-h-400 img{margin-left:auto;margin-right:auto;height:auto;width:100%}.img-max-h-400{height:auto;width:60%;max-width:130px}.image-text-vertical-column .btn-text-link{margin-top:1rem}@media (min-width:1440px){.sm-text-desktop{font-size:22px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
